import { render } from "./NewsDetailCard.vue?vue&type=template&id=1f896bac&scoped=true&ts=true"
import script from "./NewsDetailCard.vue?vue&type=script&lang=ts"
export * from "./NewsDetailCard.vue?vue&type=script&lang=ts"

import "./NewsDetailCard.vue?vue&type=style&index=0&id=1f896bac&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f896bac"]])

export default __exports__